// src/redux/cartSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  items: localStorage.getItem('cart') ? JSON.parse(localStorage.getItem('cart')) : [],
};

const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    setCartItems(state, action) {
      state.items = action.payload; // Set cart items
    },
    clearCart(state) {
      state.items = []; // Clear the cart
    },
    addToCart(state, action) {
      state.items.push(action.payload); // Add item to cart
    },
    removeFromCart(state, action) {
      state.items = state.items.filter(item => item.id !== action.payload.id); // Remove item from cart
    },
  },
});

export const { setCartItems, clearCart, addToCart, removeFromCart } = cartSlice.actions;
export default cartSlice.reducer;
